import React from 'react';
import styled, { css } from 'styled-components';
import Color from '@styles/Color';

const getColos = (props) => {
  if (props.disable) {
    return 'var(--subTextColor';
  }
  if (!props.index || !((props.index - 0) % 7)) {
    // 일요일 검사
    return Color.RED_7;
  } else if (!((props.index - 6) % 7)) {
    // // 토요일 검사
    return 'var(--subTextColor)';
  } else {
    return 'var(--textColor)';
  }
};

const cellStyle = css`
  min-height: 46px;
  height: 100%;
`;

const CellContainer = styled.div<{
  index: number;
  disable?: boolean;
  cell?: boolean;
}>`
  color: ${(props) => getColos(props)};
  border-bottom: 1px solid var(--lineColor);
  border-right: ${({ index }) =>
    (index - 6) % 7 ? '1px solid var(--lineColor)' : 0};
  overflow: hidden;
  ${({ cell }) => cell && cellStyle};
  font-size: 11px;

  &:hover {
    .addScheduleBtn {
      display: inline-block;
    }
  }
`;

const isTodayStyle = css`
  color: var(--subColor);
  font-weight: 600;

  &::before {
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50px;
    background-color: var(--primaryColor);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    z-index: -1;
  }
`;

const DayNumber = styled.div<{
  isToday?: boolean;
}>`
  position: relative;
  z-index: 1;

  ${({ isToday }) => isToday && isTodayStyle};
`;

const DayNumberSec = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-end;
  padding: 4px 2px;

  .dday {
    font-size: 12px;
    color: var(--subTextColor);
  }

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;

type Props = {
  day: any;
  index: number;
  disable?: boolean;
  onClickCell?: (day: string) => void;
  cell?: boolean;
  isToday?: any;
  children?: any;
  dday?: boolean;
};

function Cell({
  day,
  isToday,
  index,
  disable,
  onClickCell,
  cell,
  dday,
  children,
}: Props) {
  return (
    <CellContainer
      index={index}
      disable={disable}
      cell={cell}
      onClick={() => {
        if (onClickCell) onClickCell(day);
      }}
    >
      <DayNumberSec>
        <DayNumber isToday={isToday}> {day}</DayNumber>
        {dday && <span className="dday">D - 22</span>}
      </DayNumberSec>
      {children}
    </CellContainer>
  );
}

export default Cell;
